import entityContainerConnector from '~components/generic/entityContainerConnector';
import ColorShade from '~modules/palette/ColorShade';

export default entityContainerConnector(ColorShade);
